import { Box } from "@mui/material";

const Dashboards = () => {
    return(
        <Box>
            hi This is the dashboards page
        </Box>
    );
};

export default Dashboards;





// const [details, setDetails] = useState([]);
// const [saveUser, setSaveUser] = useState({
//     Name: "",
//     Number: "",
//     Location: "",
// });

// const getDetails = async () => {
//     try {
//         const response = await axios.get("https://67f87d4f2466325443ecca9e.mockapi.io/data/dataDetails");
//         setDetails(response.data);
//         console.log(response.data);
//     } catch (error) {
//         console.error("Error fetching data:", error);
//     }
// }

// getDetails(); // Fetch data when the component mounts
// // useEffect to fetch data when the component mounts

// useEffect(() => {
//     console.log("useEffect called");
// }, []);

// const handleChange = (event) => {
//     const { name, value } = event.target
//     setSaveUser({ ...saveUser, [name]: value })
// }

// console.log(saveUser);

// const [editId, setEditId] = useState(null); // State to hold the ID of the user being edited

// // Function to handle the save button click
// // This function sends a POST request to save the user data
// const handleSave = async () => {
//     try {
//         if (editId) {
//             await axios.put(`https://67f87d4f2466325443ecca9e.mockapi.io/data/dataDetails/${editId}`, saveUser);
//             setEditId(null); // Resetting editId after updating
//         }
//         else {
//             await axios.post("https://67f87d4f2466325443ecca9e.mockapi.io/data/dataDetails", saveUser);
//             setSaveUser({
//                 Name: "",
//                 Number: "",
//                 Location: ""
//             }); // Resetting the form after saving
//         }
//     } catch (error) {

//     }
// }

// // Function to handle the delete button click
// // This function sends a DELETE request to delete the user data
// const handleDelete = async (id) => {
//     try {
//         await axios.delete(`https://67f87d4f2466325443ecca9e.mockapi.io/data/dataDetails/${id}`);
//         getDetails(); // Refresh the data after deletion
//     }
//     catch (error) {
//         console.log("Error deleting data: ", error);
//     }
// }

// const handleEdit = (user) => {
//     setSaveUser({
//         Name: user.Name,
//         Number: user.Number,
//         Location: user.Location
//     });
//     setEditId(user.id); // Set the ID of the user being edited
// }



// return (
//     <Box>
//         <Box
//             sx={{
//                 width: "100%",
//                 height: "max-content",
//                 marginTop: 3,
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//             }}
//         >
//             <Paper
//                 elevation={3}
//                 sx={{
//                     width: "25%",
//                     padding: 2,
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: 2,
//                     alignItems: "center",
//                     justifyContent: "center",
//                 }}
//             >
//                 {details.map((card) => (
//                     <Paper elevation={3} sx={{
//                         height: " 30vh",
//                         display: "flex",
//                         flexDirection: "column",
//                         padding: 2,
//                         paddingLeft: 3,

//                     }} key={card.id}>
//                         <h1 style={{ textAlign: "center", marginTop: 0 }}>{card.Name}</h1>
//                         <p><strong> Number:</strong> {card.Number}</p>
//                         <p> <strong> Location:</strong> {card.Location}</p>
//                         <Button variant="contained" color="primary" onClick={() => handleDelete(card.id)}>Delete</Button>
//                         <Button sx={{marginTop:"5px"}} variant="contained" color="primary" onClick={() => handleEdit(card)}>Edit</Button>
//                     </Paper>
//                 ))}
//             </Paper>
//         </Box>

//         <Box
//             sx={{
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//             }}>
//             <Paper elevation={3} sx={{
//                 width: "25%",
//                 height: "max-content",
//                 marginTop: 5,
//                 padding: 2,
//                 gap: 2,
//                 display: "flex",
//                 flexDirection: "column",
//             }}>
//                 <Typography variant="h4" sx={{ textAlign: "center", fontWeight: "bold" }}>{editId ? "UPDATE USER" : "ADD USER"}</Typography>
//                 <TextField
//                     id="outlined-basic"
//                     label="Name"
//                     variant="outlined"
//                     name="Name"
//                     value={saveUser.Name}
//                     onChange={(event) => { handleChange(event) }}
//                     fullWidth
//                 />
//                 <TextField
//                     id="outlined-basic"
//                     label="Number"
//                     variant="outlined"
//                     name="Number"
//                     value={saveUser.Number}
//                     onChange={(event) => { handleChange(event) }}
//                     fullWidth
//                 />

//                 <TextField
//                     id="outlined-basic"
//                     label="Location"
//                     variant="outlined"
//                     name="Location"
//                     value={saveUser.Location}
//                     onChange={(event) => { handleChange(event) }}
//                     fullWidth
//                 />
//                 <Button variant="contained" color="primary" onClick={handleSave}>{editId ? "Update" : "Save"}</Button>
//             </Paper>
//         </Box>